<template>
    <div v-if="isVisible" class="cookies-info-box">
        <div class="content-wrapper">
            <div class="cookies-copy">
                <p>
                    Strona korzysta z plików cookies w celu realizacji usług i
                    zgodnie z
                    <a
                        target="_blank"
                        href="https://allegro.pl/regulaminy/polityka-plikow-cookies-lDzYv9wn8Tn"
                        >Polityką Plików Cookies</a
                    >. Możesz określić warunki przechowywania lub dostępu do
                    plików cookies w Twojej przeglądarce.
                </p>
            </div>
            <div class="cookies-actions">
                <button @click.prevent="closeInfo()">Zamknij</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isVisible: false
        };
    },
    methods: {
        closeInfo: function() {
            document.cookie =
                "wosp_allegro_cookie=1; expires=Fri, 31 Dec 2021 23:59:59 GMT";
            this.isVisible = false;
        }
    },
    mounted() {
        let cookie = document.cookie.match(
            "(^|;) ?" + "wosp_allegro_cookie" + "=([^;]*)(;|$)"
        );
        if (cookie) {
            this.isVisible = false;
        } else {
            this.isVisible = true;
        }
    }
};
</script>
